import React from 'react';

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  /** Optional element shown on the right (e.g. a "see all" button). */
  action?: React.ReactNode;
  /** `page` = the page's h1, `section` = a smaller h2 inside a page. */
  level?: 'page' | 'section';
}

/** Red left-bordered heading used at the top of every listing page. */
export const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  subtitle,
  action,
  level = 'page',
}) => {
  const Heading = level === 'page' ? 'h1' : 'h2';
  const size = level === 'page' ? 'text-3xl md:text-5xl' : 'text-2xl md:text-4xl';

  return (
    <div className="flex flex-col md:flex-row md:items-center md:justify-between gap-4">
      <div className="border-l-4 border-neon-red pl-4">
        <Heading
          className={`${size} font-bold uppercase tracking-tighter leading-tight md:leading-tight`}
        >
          {title}
        </Heading>
        {subtitle && <p className="text-neutral-400 font-body mt-2">{subtitle}</p>}
      </div>
      {action}
    </div>
  );
};
